import { Text } from '@chakra-ui/react'

import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import CustomFormFileAnswer from 'components/tools/CustomForm/commonComponents/CustomFormSingleFileAnswer'
import CustomFormEmptyAnswerFeedback from 'components/tools/CustomForm/commonComponents/CustomFormEmptyAnswerFeedback'

export default function CustomFormSingleFileAnswer() {
  const { answer } = useCustomFormAnswer()

  const answerValue = (answer.answer as string[]) || []

  if (answerValue?.length == 0) {
    return (
      <Text variant="secondary" fontStyle="italic">
        Sem resposta
      </Text>
    )
  }

  return (
    <CustomFormEmptyAnswerFeedback>
      <CustomFormFileAnswer fileId={answerValue[0]} fileSlug={answerValue[1]} archiveId={answerValue[2]} />
    </CustomFormEmptyAnswerFeedback>
  )
}
